import React, { useEffect, useState } from "react";
import {OfficeDetailsID} from "../../common/queries/common_use_query"

const LeadooProperty = ({property_data, search_type}) => {
    const[office_det, setOfficeDet] = useState([]);

    const{loading, error, data} = OfficeDetailsID(property_data.office_crm_id ? property_data.office_crm_id : "");

    useEffect(() => {
        if(loading){

        } else {
            if(typeof window !== "undefined"){
                var advert_address = property_data?.display_address
    
                //console.log("office_det==>", office_det)
                if(office_det?.name){
                    window.newObject = {data: {branch_name: office_det?.name, office_id: property_data?.office_crm_id, advert_address: advert_address, advert_postcode:property_data.address.postcode}}; 
                } else{
                    window.newObject = {data: {office_id: property_data?.office_crm_id, advert_address: advert_address, advert_postcode:property_data.address.postcode}}; 
                }
            }
        }
    }, [property_data, office_det, loading])

    useEffect(() => {
        data?.offices?.length > 0 && setOfficeDet(data?.offices[0]);
    }, [data])

    var advert_addr = property_data?.display_address

    return (
        <>
        {loading ? '' :
            <div className="leadooChat">
                {office_det?.name ? 
                    <ld-slot name={search_type} branch_name={office_det?.name} office_id={property_data?.office_crm_id} advert_address={advert_addr} advert_postcode={property_data.address.postcode}></ld-slot>
                :
                    <ld-slot name={search_type} office_id={property_data?.office_crm_id} advert_address={advert_addr} advert_postcode={property_data.address.postcode}></ld-slot>
                }
            </div>
        }
        </>
    );
};
export default LeadooProperty;